import React from "react";

import { AllTemplateTypes } from "../../constants/template-types";

import {
  Dropdown,
  DropdownButton,
  DropdownItem,
  DropdownItems,
} from "@transfr-inc/dashboard-components/forms";

export function TemplateTypeDropdown({
  className,
  onTypeSelected,
  selectedType,
}) {
  return (
    <Dropdown
      className={className}
      selected={selectedType}
      onOptionSelected={onTypeSelected}
    >
      <DropdownButton
        placeholder={"Select a template type..."}
        icon={selectedType?.icon}
      >
        {selectedType?.displayName}
      </DropdownButton>
      <DropdownItems>
        {AllTemplateTypes.map((type) => (
          <DropdownItem key={type.id} value={type}>
            {type.displayName}
          </DropdownItem>
        ))}
      </DropdownItems>
    </Dropdown>
  );
}
